/**
 * Dev-only QA switch for checking the migration of manual test results:
 * `?mtjson=1` on the page makes the API read them from the old JSON files and
 * refuse to save. Removed before the preview release.
 */
export function isManualTestJsonView(): boolean {
  return (
    typeof window !== 'undefined' &&
    // Only on the test page: elsewhere, such as My Goals, a test without a
    // file would answer an error the page reads as a deleted test.
    window.location.pathname.includes('/report/manual-tests/test/') &&
    new URLSearchParams(window.location.search).get('mtjson') === '1'
  );
}
